import { Container, Typography, ThemeProvider, Box, TextField, InputAdornment, IconButton, Divider } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

import axios from 'axios';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { createNewTheme } from '../functions/utils';
import { ContentCopy } from '@mui/icons-material';
import { ButtonGustio } from '../components/DesignSystem/ButtonGustio';
import CountdownTimer from '../components/DesignSystem/CountdownTimer';
import { Accordion, AccordionDetails, AccordionSummary } from '../components/utils';
import { SpacerGustio } from '../components/DesignSystem/SpacerGustio';

function Finalizado() {

  const navigate = useNavigate();
  const state = useLocation().state;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [urlRedirect, setUrl] = useState("");
  const [isMesa, setIsMesa] = useState("");
  const [pedidos, setPedidos] = useState("");
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [expanded, setExpanded] = useState(false);

  const handleBack = () => {
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      navigate(`/?nm=${btoa(numeroMesa)}`, { replace: true, state: { page: "home" } })
    } else {
      navigate("/", { replace: true, state: { page: "home" } })
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const getChavePix = () => {
    return localStorage.getItem('cvP');
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const handlePedidos = (id) => {
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      navigate(`/?nm=${btoa(numeroMesa)}`, { replace: true, state: { page: "pedidos" } })
    } else {
      if (localStorage.getItem('isLogged')) {
        navigate("/", { replace: true, state: { page: "pedidos" } })
        return
      }
      localStorage.setItem('idpT', id);
      navigate(`/pedido/${id}`, { replace: true, state: { page: "pedidos", colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    }
  };

  const handleCopy = async (qrcode) => {
    try {
      const chavePix = localStorage.getItem('cvP');
      await navigator.clipboard.writeText(qrcode ? qrcode : chavePix);
      handleSnack("Chave PIX copiada com sucesso.")
    } catch (err) {
      handleSnack("Não foi possivel copiar a chave PIX")
    }
  };

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;

    const urlMessage = localStorage.getItem('UMs');
    setUrl(urlMessage);
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      setIsMesa(true);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getPedidos(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getPedidos = (idp) => {
    const urlBase = localStorage.getItem('UBs');
    axios.get(`${urlBase}/pedido.php?idpedidos=${idp}`)
      .then(resp => {
        const response = resp.data;
        if (response) {
          setPedidos(response);
          setTimeout(() => {
            localStorage.setItem('idpT', response[0]?.data);
            navigate(`/pedido/${response[0]?.data}`, { replace: true, state: { page: "pedidos", colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
          }, 10000);

          handleCloseLoading();
        }
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getQrCode = (retornoPagarme) => {
    const json = JSON.parse(retornoPagarme);
    if (json?.charges[0]?.last_transaction?.qr_code_url) {
      return <Box>
        <CountdownTimer expiresAt={json.charges[0].last_transaction?.expires_at} />
        <strong>Pix QR Code</strong>
        <br />
        Aproxime a câmera do seu dispositivo para escanear o QR Code, ou clique no botão abaixo para copiar!
        <Box alt="qrcode" component="img" src={json.charges[0].last_transaction.qr_code_url} style={{ width: "200px", height: "200px" }} />
        <TextField
          fullWidth
          value={json.charges[0].last_transaction.qr_code}
          variant="outlined"
          sx={{ mt: 2 }}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => handleCopy(json.charges[0].last_transaction.qr_code)}>
                  <ContentCopy />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Box>
    } else {
      return <>Chave PIX: <b>{getChavePix()}</b></>
    }
  }

  const handleChange = (newExpanded) => {
    setExpanded(!newExpanded);
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>

        <LoadingComponent open={loading} />

        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleClose}
          message={msgSnack}
        />

        {/* <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#1B1B1B" }} onClick={handleBack}>
          <CloseOutlined />
        </IconButton> */}

        <SpacerGustio height={60} />
        {pedidos && (
          <>
            <Box style={{ position: "relative", left: 0, width: "100%" }}>
              <Typography style={{ textAlign: "center", fontSize: "14px", color: "#999" }}>

                <img alt="success" src="https://gustio.com.br/imagens/smiling-face.png" style={{ width: "70px" }} />

                <Typography style={{ textAlign: "center", fontSize: "24px", color: "#1B1B1B" }}>
                  Pedido #{pedidos[0].data}
                </Typography>

                {isMesa ? (
                  <Typography style={{ textAlign: "center" }}>
                    Seu pedido foi realizado com sucesso, em breve estará em sua mesa!
                  </Typography>
                ) : (
                  <Typography style={{ textAlign: "center" }}>
                    Seu pedido foi realizado com sucesso!
                    {/* Seu pedido foi realizado com sucesso, uma cópia foi enviada ao seu whatsapp! */}
                  </Typography>
                )}

                <SpacerGustio height={20} />

                <Box>
                  <Accordion expanded={expanded} onChange={() => handleChange(expanded)} style={{ borderRadius: "8px" }}>
                    <AccordionSummary aria-controls="ajuda" id="fechado">
                      <Typography component="span">Detalhes do seu pedido:</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{ width: "100%", textAlign: "left", fontSize: 13, fontWeight: 600 }}>Itens</Typography>
                      {(JSON.parse(atob(pedidos[0].detalhes))).map((detalhes) => (
                        <>
                          <Typography style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                            {detalhes.quantidade}x {detalhes.nome} <b>R$ {detalhes.valorTotal}</b>
                          </Typography>
                        </>
                      ))}
                      <SpacerGustio height={10} />
                      <Divider />
                      <SpacerGustio height={10} />
                      <Typography style={{ width: "100%", textAlign: "left", fontSize: 13, fontWeight: 600 }}>Resumo de valores</Typography>
                      <Typography style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                        Taxa de entrega: <b>{(pedidos[0].taxa !== "" && pedidos[0].taxa !== "Grátis" && pedidos[0].taxa !== "combinar") ? `R$ ${pedidos[0].taxa}` : `-`}</b>
                      </Typography>
                      <Typography style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                        Valor total: <b>R$ {pedidos[0].valor}</b>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>

                <SpacerGustio height={30} />

                {pedidos[0].formapagamento === "PIX" && (
                  <Typography style={{ display: "flex", fontSize: "12px" }}>
                    {getQrCode(pedidos[0].retornopagarme)}
                  </Typography>
                )}
                <SpacerGustio height={10} />
                {pedidos[0].formapagamento === "PIX" && !pedidos[0].retornopagarme && (
                  <>
                    <ButtonGustio variant="contained" fullWidth onClick={handleCopy} target="_blank">Copiar chave PIX</ButtonGustio>
                  </>
                )}

              </Typography>
              <SpacerGustio height={20} />
            </Box>

            <Box style={{}}>
              <Typography style={{ fontSize: "12px", color: "#999", textAlign: "center" }}>
                {pedidos[0].formapagamento === "PIX" && !pedidos[0].retornopagarme ?
                  <>Caso ja tenha efetuado o pagamento envie o comprovante clicando no botão abaixo!</>
                  :
                  <>Está com alguma dúvida sobre o seu pedido? <br />Fale com o estabelecimento clicando no botão abaixo!</>}
              </Typography>
              <SpacerGustio height={10} />
              {pedidos[0].formapagamento === "PIX" && (
                <ButtonGustio href={urlRedirect} target="_blank">Enviar comprovante de pagamento</ButtonGustio>
              )}
              {pedidos[0].formapagamento !== "PIX" && !isMesa && (
                <ButtonGustio href={urlRedirect} target="_blank">Falar com estabelecimento</ButtonGustio>
              )}
              <SpacerGustio height={20} />
              <ButtonGustio onClick={() => handlePedidos(pedidos[0].data)}>
                Pedidos
              </ButtonGustio>
            </Box>
          </>

        )}

        <SpacerGustio height={20} />

      </Container>
    </ThemeProvider>
  );
}

export default Finalizado;